import React, { useEffect, useState } from 'react';
import { getContactForms } from '../../services/api';
import { toast } from 'sonner';

export default function ContactsManagement() {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContacts();
  }, []);

  const fetchContacts = async () => {
    try {
      const response = await getContactForms();
      setContacts(response.data);
    } catch (error) {
      toast.error('İletişim mesajları yüklenirken hata');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="text-center py-12">Yükleniyor...</div>;

  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-900 mb-6">İletişim Mesajları</h2>
      <div className="space-y-4">
        {contacts.length === 0 ? (
          <div className="text-center py-12 text-gray-500">Mesaj bulunamadı</div>
        ) : (
          contacts.map((contact) => (
            <div key={contact.id} className="bg-white rounded-2xl p-6 border">
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="font-bold text-lg text-gray-900">{contact.name}</h3>
                  <p className="text-sm text-gray-500">{contact.email}</p>
                  {contact.phone && <p className="text-sm text-gray-500">{contact.phone}</p>}
                </div>
                <span className="text-xs text-gray-400">{new Date(contact.created_at).toLocaleDateString('tr-TR')}</span>
              </div>
              <div className="mb-3"><strong className="text-sm">Konu:</strong> {contact.subject}</div>
              <div className="text-sm bg-gray-50 rounded-lg p-4">{contact.message}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}